/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { TextField, Paper, Divider, FormControl, FormControlLabel, Checkbox, OutlinedInput, InputLabel, IconButton, Typography  } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({
    field : {
        boxSizing: 'border-box', 
        margin : '1%', 
        width : '48%'
    }
})

class DisplayComponent extends Component {
    state = {
        label : "",
        key_source : '',
        key_name : '',
        style : ''
    }

    getValueObject = (value, valueSet) => {
        if (value === "") {
            return ""
        }   
        let value_index = valueSet.findIndex(el => el.value === value)
        let value_object = valueSet[value_index]

        return value_object
    }

    renderDelete = () => {
        if (this.props.delete === true) {
            return (
                <IconButton size = 'small' color = 'secondary' onClick = {() => this.props.delete_field(this.props.id)} disabled = {!this.props.edit}>
                    <DeleteIcon fontSize = 'small'/>
                </IconButton>
            )
        }
    }

    getErrorState = (raw_fields_state, eval_value, field_value) => {
        if (this.props.raw_fields === raw_fields_state) {
            if (field_value === eval_value) {
                return true
            } else {
                return false
            }
        }
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper variant = 'outlined' style = {{
                    width : '98%',
                    backgroundColor : '#FAFBFC', 
                    boxSizing: 'border-box', 
                    display: 'flex', 
                    flexDirection : 'row',
                    padding : '5px',
                    margin :'1%'
                }}>
                    <div style = {{
                        width : '95%',
                        display: 'flex', 
                        flexDirection : 'row', 
                        flexWrap : 'wrap',
                    }}>
                        <FormControl className = {classes.field} size = 'small' label = 'Label' disabled = {!this.props.edit}>
                            <OutlinedInput
                                color = 'primary'
                                value = {this.props.label}
                                onChange = {(event) => this.props.updateConfig(this.props.id, this.props.label_field, event.target.value)}
                            />
                        </FormControl>
                        <Autocomplete
                            className = {classes.field}
                            color = 'primary'
                            id="style"
                            options={this.props.field_styles}
                            disabled = {!this.props.edit}
                            value = {this.getValueObject(this.props.field_style, this.props.field_styles)}
                            onChange={(event, newValue) => {
                                this.props.updateConfig(this.props.id, this.props.style_field, newValue.value)
                            }}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Field Style" size = 'small' variant="outlined" />}
                        />
                        <Autocomplete
                            id="field-source"
                            className = {classes.field}
                            color = 'primary'
                            options={this.props.field_sources}
                            disabled = {!this.props.edit}
                            getOptionLabel={(option) => option.label}
                            getOptionDisabled={(option) => this.props.raw_fields === true ? null : option.value === "raw_data"}
                            value = {this.getValueObject(this.props.field_source, this.props.field_sources)}
                            onChange={(event, newValue) => {
                                this.props.updateConfig(this.props.id, this.props.field_source_field, newValue.value)
                            }}
                            renderInput={(params) => <TextField {...params} label="Field Source" size = 'small' variant="outlined" />}
                        />
                        <Autocomplete
                            id="field-name"
                            className = {classes.field}
                            color = 'primary'
                            options={this.props.field_names}
                            value = {this.props.field_name}
                            disabled = {!this.props.edit}
                            onChange={(event, newValue) => {
                                this.props.updateConfig(this.props.id, this.props.field_name_field, newValue)
                            }}
                            renderInput={(params) => <TextField {...params} label="Field Name" size = 'small' variant="outlined" />}
                        />
                        {this.props.attachment_settings && <FormControlLabel
                            className = {classes.field}
                            control={
                                <Checkbox
                                size = 'small'
                                checked = {this.props.field_attachments}
                                name="checkedB"
                                color="primary"
                                onChange = {(event) => {
                                    this.props.updateConfig(this.props.id, this.props.field_attachment_key, event.target.checked)
                                }}
                                />
                            }
                            label = {<Typography variant = 'body2'>Show Field Attachments</Typography>}
                            labelPlacement = "end"
                        />}
                        {this.props.attachment_settings && <FormControlLabel
                            className = {classes.field}
                            control={
                                <Checkbox
                                size = 'small'
                                checked = {this.props.embedded_attachments}
                                name="checkedB"
                                color="primary"
                                onChange = {(event) => {
                                    this.props.updateConfig(this.props.id, this.props.embedded_attachment_key, event.target.checked)
                                }}
                                />
                            }
                            label = {<Typography variant = 'body2'>Render Embedded Attachments</Typography>}
                            labelPlacement = "end"
                        />}
                    </div>
                    <div style = {{width : '5%'}}>
                        {this.renderDelete()}
                    </div>
                </Paper>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(DisplayComponent);